import React from 'react';

export default function XIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M9.08342 1.73913L8.26092 0.916626L5.00008 4.17746L1.73925 0.916626L0.916748 1.73913L4.17758 4.99996L0.916748 8.26079L1.73925 9.08329L5.00008 5.82246L8.26092 9.08329L9.08342 8.26079L5.82258 4.99996L9.08342 1.73913Z"
                fill="black"
            />
        </svg>
    );
}
